import DesingerLead from "../views/leads/DesingerLead"
import ConsultetionLead from "../views/leads/ConsultationLead"


var routes = [
    {
        path: '/desinger-leads',
        name: "DesingerLead",
        component: DesingerLead
    },
    {
        path: '/consultetion-leads',
        name: "ConsultetionLead",
        component: ConsultetionLead
    },
]

export default routes